import React, { Component } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../utils/font-awesome';

class ProjectIcon extends Component {
    onClick = () => {
      const { label, color, onClick } = this.props;
      onClick(label, color);
    }
  
    render() {
      const {
        onClick,
        props: {
          activeColor,
          label,
          color
        },
      } = this;

      const StyledIcon = styled.a`
        display: block;
        position: relative;
        text-align: center;
        width: 48px;
        height: 48px;
        font-size: 24px;
        line-height: 1.8;
        border-radius: 50%;
        margin-right: 24px;
        cursor: ${color === activeColor ? 'auto' : 'pointer'};
        border: 2px solid ${color === activeColor ? activeColor : 'transparent'};
        color: ${color === activeColor ? activeColor : '#768273'};
        &:hover {
          color: ${color};
        }
      `

      return (
        <StyledIcon 
          onClick={onClick}
        >
          <FontAwesomeIcon icon={label} />
        </StyledIcon>
      );
    }
  }
  
  export default ProjectIcon;